<template>
  <v-app>
    <AppNavDrawer ref="nav" :nav="nav" :user="usuario" :avatar-url="url"
      :open.sync="navOpen" :mini.sync="navMini" />
    <AppBar :sucursal="nameSucursal" :user="usuario" :avatar-url="url"
      @toggle-nav="toggleNav" @search="searchOpen = true" />
    <v-main class="app-main">
      <router-view />
    </v-main>
    <Footer :footer="'Sistema de ventas para la ' + nameSucursal " />
    <ModuleSearch v-model="searchOpen" :nav="nav" />
  </v-app>
</template>

<script>
import UsuarioDataService from "@/service/usuario/UsuarioDataService";
import SucursalDataService from "@/service/catalogo/sucursal/sucursalDataService";
import Footer from "@/components/shared/Footer.vue";
import imageProfile from "@/assets/user.png";
import AppBar from "@/components/shared/AppBar.vue";
import AppNavDrawer from "@/components/shared/AppNavDrawer.vue";
import ModuleSearch from "@/components/shared/ModuleSearch.vue";
import createPermissions from "@/service/permiso/Permisos";
import { buildNav, loadNavMini, saveNavMini } from "@/service/permiso/menuModel";
import { extractMessage } from "@/helpers/errorHelper";

export default {
  name: "principal-layout",
  components: { Footer, AppBar, AppNavDrawer, ModuleSearch },
  created() {
    this.getUser();
  },
  mounted() {
    window.addEventListener("keydown", this.onKeydown);
  },
  beforeDestroy() {
    window.removeEventListener("keydown", this.onKeydown);
  },
  data: () => ({
    usuario: {},
    url: imageProfile,
    nav: [],
    navOpen: false,
    navMini: loadNavMini(),
    searchOpen: false
  }),
  watch: {
    navMini(mini) {
      saveNavMini(mini);
    }
  },
  methods: {
    toggleNav() {
      this.$refs.nav.toggle();
    },
    // Ctrl K / Cmd K abre el buscador de módulos
    onKeydown(event) {
      if ((event.ctrlKey || event.metaKey) && String(event.key).toLowerCase() === "k") {
        event.preventDefault();
        this.searchOpen = true;
      }
    },
    getUser() {
      const storeAuth = this.$store.state.auth;
      UsuarioDataService.getProfile(storeAuth.user.id)
        .then(response => {
          if (response.status == 200) {
            const { data: row, data: { roleName: roles, imagen } } = response;
            this.$store.dispatch("auth/setUser", row);
            this.usuario = row;
            this.nav = buildNav(createPermissions(roles));
            if (imagen != null && imagen.length > 0) {
              this.url = `${storeAuth.rutaFichero}avatars/${imagen}`;
            }
          }
        })
        .catch(error => {
          this.$swal.fire({
            position: "top-end",
            icon: "error",
            text: extractMessage(error),
            title: "Error al obtener el perfil",
            showConfirmButton: false,
            timer: 1500
          });
        });
    }
  },
  computed: {
    nameSucursal() {
      return SucursalDataService.getCurrentSucursal()?.nombre || "";
    }
  }
};
</script>
<style scoped>
/* crema de paja detrás de todas las pantallas; las tarjetas y tablas blancas se despegan solas */
.v-main.app-main {
  background-color: var(--app-canvas);
}
</style>
